/**
 * 存放事件函数
 */
const EventStack = {},
  FnNameMap = {};
// uuid = 0;
/**
 * 自定义事件，可自行添加，也可引用内置事件
 */
export const EVENTNAMES = {
  HISTORYBACK: 'historyBack',
};
/**
 * 添加自定义事件方法,需要注意的是如果是 historyback 事件，
 * fn 必须返回一个bool值，用以标识是否拦截URL更改操作
 * @param {String} eventName 自定义事件名称
 * @param {function} fn 监听自定义事情的处理方法
 * @returns {Number} eventID
 */
export const addEvent = (eventName, fn) => {
  if (!EventStack[eventName]) {
    EventStack[eventName] = [];
  }
  let name = fn.name;
  let eventID = EventStack[eventName].push(fn) - 1;
  if (name) {
    FnNameMap[eventName][name] = eventID;
  }
  return eventID;
};
/**
 * 删除定义的事件方法
 * @param {String} eventName 自定义事件名称
 * @param {function} fn 可以事自定义事件函数 也可以是eventID
 * @returns {Boolean} 返回解绑的结果
 */
export const removeEvent = (eventName, fn) => {
  if (!eventName) return '请传入需要取消监听的事件名称';
  if (!EventStack[eventName]) return;
  let index = -1;
  if (typeof fn === 'function') {
    index = FnNameMap[eventName];
  } else {
    index = fn;
  }
  if (index != -1) {
    EventStack[eventName].splice(index, 1);
    return true;
  }
  return false;
};
/**
 * 触发定义的事件
 * @param {String} eventName
 * @param {*} args 触发事件时的入参
 * @returns {Boolean} 回调结果 eventName === 'historyBack'
 */
export const fireEvent = (eventName, ...args) => {
  let stacks = EventStack[eventName],
    isHistoryBackEvent = eventName === EVENTNAMES.HISTORYBACK;
  if (stacks && stacks.length) {
    for (let len = stacks.length; --len >= 0; ) {
      let fn = stacks[len];
      if (typeof fn === 'function') {
        let _result = fn(eventName, args);
        if (!_result && isHistoryBackEvent) {
          return false;
        }
      }
    }
  }
  return true;
};
